<template>
  <table class="table">
    <thead>
      <tr>
        <th v-for="column in columns"
            :key="column[columnOptions.key]"
            @click="sortTableEvent(column[columnOptions.key])"
            @mouseover="bootstrapmouseover"
            @mouseleave="bootstrapmouseleave">
          {{ column.title }} <i :class="findSortIconById(column[columnOptions.key])" class="fa" aria-hidden="true" />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in sortedRows" :key="row.id">
        <template v-for="column in columns">
          <th v-if="column[columnOptions.key] === columnOptions.key" :key="column[columnOptions.key]" scope="row">{{ row[column[columnOptions.key]] }}</th>
          <td v-else :key="column[columnOptions.key]"> {{ row[column[columnOptions.key]] }}</td>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<script>

  export default {
    components: {
    },
    props: {
      rows: {
        type: Array,
        default() {
          return []
        }
      },
      columns: {
        type: Array,
        default() {
          return [{
            id: 1,
            title: ''
          }]
        }
      },
      columnOptions: {
        type: Object,
        default() {
          return {
            key: 'id',
          }
        }
      }
    },
    data() {
      return {
        filterInput: '',
        currentPostSortColumn: '',
        currentPostSortOrder: '',
      }
    },
    computed: {
      sortedRows: function () {
        if (this.currentPostSortColumn && this.currentPostSortOrder) {
          const comparer = this.currentPostSortOrder !== 'desc' ? 1 : -1;
          return this.rows.slice().sort((a, b) => {
                if (a[this.currentPostSortColumn] < b[this.currentPostSortColumn]) {
                  return -comparer;
                }
                if (a[this.currentPostSortColumn] > b[this.currentPostSortColumn]) {
                  return comparer;
                }
                return 0;
              }
          )
        }
        return this.rows
      }
    },
    methods: {
      sortTableEvent(columnId) {
        if (this.currentPostSortColumn !== columnId) {
          this.currentPostSortColumn = columnId
        }
        this.toggleSortOrder()
      },
      toggleSortOrder() {
        if (this.currentPostSortOrder === 'asc') {
          this.currentPostSortOrder = 'desc'
        } else if (this.currentPostSortOrder === 'desc') {
          this.currentPostSortOrder = ''
        } else {
          this.currentPostSortOrder = 'asc'
        }
      },
      findSortIconById(columnId) {
        if (columnId === this.currentPostSortColumn) {
          if (this.currentPostSortOrder === 'asc') {
            return 'fa-sort-asc';
          }
          if (this.currentPostSortOrder === 'desc') {
            return 'fa-sort-desc';
          }
        }
        return 'fa-sort';
      },
      bootstrapmouseover(e) {
        e.target.classList.add('bg-light')
      },
      bootstrapmouseleave(e) {
        e.target.classList.remove('bg-light')
      },
    },
  }
</script>


<style scoped>
  th {
    cursor: pointer;
  }
</style>
